import { UntypedFormGroup } from '@angular/forms';
import { DropDownFormSectionData } from '../dropdown-form-section/dropdown-form-section-data';
export class OrderFormSectionData {
  parentForm: UntypedFormGroup;
  titleText: string;
  subtitleText: string;
  descriptionText: string;
  iconUrl: string;
  primarySection: DropDownFormSectionData;
  subsections: DropDownFormSectionData[];
  footerText?: string;
}
